import React, { useEffect, useRef, useState } from 'react';
import { AssignmentStatus, TreatmentModel, TreatmentType } from '../models/superbit-api-models';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faTelegram, IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { faBan, faBell, faCheck, faCircle, faCircleCheck, faCircleExclamation, faCircleHalfStroke, faClock, faList, faPaperclip, faPhone, faRectangleXmark, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, MenuProps, Select, Tooltip } from 'antd';
import { tr } from 'date-fns/locale';
import { SuesModel } from '../models/SuesModel';
import { GeneralDataModel } from '../models/GeneralDataModel';
import "./_SuesTable.css";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCreateTreatmentFrom } from '../app-context/tasksSlice';
import { setSueInsuranceCompanyId } from '../app-context/suesSlice';

type Props = {
    details: any;
    statuses?: any[];
    config: any;
    actions: any
    fromClient?: boolean;
};

const SueItem =(props: Props)=> {
    const suesModel: SuesModel = new SuesModel();
    const generalModel: GeneralDataModel = new GeneralDataModel();
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const [sueItem, setSueItem] = useState<any>(props.details);
    const [signingItemPrev, setSigningItemPrev] = useState<any>(props.details);
    const [riderItem, setRiderItem] = useState<any | null>(null);
    const [suesMenuOptions, setSuesMenuOptions] = useState<MenuProps['items']>([]);
    const [riderMenuOptions, setRiderMenuOptions] = useState<MenuProps['items']>([]);
    const [apiUrl, setApiUrl] = useState<string>('');
    const [additionalColumns, setAdditionalColumns] = useState<any>(props.config.additionalColumns);
    const [statusId, setStatusId] = useState<string>('0');
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [showOnlyRiders, setShowOnlyRiders] = useState<boolean>(false);

    const [hasChanges, setHasChanges] = useState<boolean>(false);
    const [changesSaved, setChangesSaved] = useState<boolean>(false);
    const [changeComments, setChangeComments] = useState<any[]>([]);

    const [iconClass, setIconClass] = useState<string>('no-color');
    const [insuranceTypes, setInsuranceTypes] = useState<any[]>([]);
    const [insuranceTypeLabel, setInsuranceTypeLabel] = useState<any[]>([]);

    const [typesVechicle21Day, setTypesVechicle21Day] = useState<string[]>([
        '988a0ecc-2ff5-45e1-aa9f-260db7a5c53f',
        '3895630a-9640-462c-ad22-9f7bd0abc45b',
        'c7cbea40-2433-4432-b0e6-06af4d84a84f',
        '23a6e7f8-ef7d-4686-b7a9-532d04ae7d1a',
        'ead7f163-6818-4acc-82d1-29b10b8a787f',
        '1185cb5f-ea14-4a97-a960-caf6d140846e',
        'ec6aef8c-fb4a-49c8-9a7c-1422357a1ba1'
    ])
    const [typesVechicle45Day, setTypesVechicle45Day] = useState<string[]>([
        'e7e8c86d-25ed-4817-bac6-47eee6cb5729',
        'bcf3e381-f4aa-4062-b57a-d8fa0dc662af'
    ])


    const isValidUrl = (input: string): boolean => {
        const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*(\?.*)?(#.*)?$/i;
        return urlPattern.test(input);
    }

    const isHTML = (str: string): boolean => {
        const htmlPattern = /<\/?[a-z][\s\S]*>/i;
        return htmlPattern.test(str);
    }
    
    const downloadDocument = (docUrl: string | undefined) => {
        if(apiUrl !== '' && docUrl) {
            const fileUrl = `${apiUrl}${docUrl}`;
            console.log('downloadDocument', fileUrl );
            const anchor = document.createElement('a');
            anchor.href = fileUrl;
            anchor.target='_blank';
            anchor.download = 'filename.pdf'; // Set the filename you want
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }


    const onMenuClicked = (type: string)=>{
        switch (type) {
            case 'edit':
                console.log('editTask');
                if(props.actions.edit) {
                    // props.actions.edit(sueItem.id);
                }
                break;
            case 'delete':
                console.log('editTask');
                if(props.actions.delete) {
                    // props.actions.delete(sueItem.id);
                }
                break;
            case 'assignToHandler':
                if(props.actions.onAssignToHandler) {
                    // props.actions.onAssignToHandler(sueItem.id);
                }
                break;
            
            default:
                break;
        }
    }

    const onSelectSigning = () => {
        if (props.actions && props.actions.onSelectSigning) {
            // console.log('props.actions.onSelectSigning', props.actions.onSelectSigning)
            props.actions.onSelectSigning(sueItem.id);
        }
    }

    const addSigningComment = (comment: string)=> {
        if (props.actions && props.actions.addSigningComment) {
            const data = {    
                "TreatmentType": 4,
                "AlertDate": moment().format('YYYY-MM-DDTHH:mm'),
                "Topic": comment,
                "PolicyRelatedId": sueItem.policy.id,
                'Seen':true
            }
            props.actions.addSigningComment(data);
        }
    }

    const onRowClick = (e: any) => {
            // if (e.target.className == 'act-btn-icon icon menu-hamburger pointer' ||
            //     e.target.className == 'action-btn-menu-item pointer' ||
            //     e.target.className == 'ant-select-selection-item' ||
            //     e.target.className == 'ant-select-item-option-content' ||
            //     e.target.className == 'icon paperclip pointer' ||
            //     e.target.className == 'pointer checkbox' ||
            //     e.target.className == 'description bold cell-value phone-number' ||
            //     e.target.className == 'client-name' ||
            //     e.target.parentElement.className == 'car-details' ||
            //     e.target.parentElement.className == 'actions' ||
            //     e.target.parentElement.className.indexOf('on-click-ignore') > 0
            // ) {return;}
            onSelectSigning();
    }

    const displayCarLicense = () => {
        if (sueItem.vehicle && sueItem.vehicle.licenseNumber && sueItem.vehicle.licenseNumber !== '') {
            const license =sueItem.vehicle.licenseNumber
            const cleaned = license.replace(/\D/g, "");
            return cleaned;
            // if (cleaned.length == 8)  {
            //     return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5)}`; // Format as XXX-XXX
            // } else {
            //     return cleaned;
            // }
        }
    }

    
    const onStatusChange = async (value: string) => {
        if (value == '0') {
            return;
        }
        const currentData = sueItem;
        if (props.statuses) {
            let prevStatus = props.statuses.find((s :any) => s.value === currentData.elementaryPolicyStatusId);
            if (!prevStatus) {
                prevStatus = {
                    value: 0,
                    label: 'חדש'
                }
            }
            let newStatus = props.statuses.find((s :any) => s.value === value);
            if (!newStatus) {
                newStatus = {
                    value: 0,
                    label: 'חדש'
                }
            }
            const comment = `סטטוס שונה מ- ${prevStatus.label} ל-${newStatus.label}`;
            // addSigningComment(comment);
            const comments = changeComments;
            comments.push(comment);
            setChangeComments(comments);
        }
        setStatusId(value);
        currentData.elementaryPolicyStatusId = value;
        await setSueItem(currentData);
        // onUpdate();
        setHasChanges(true);
        // buildMenuOptions();
    }

    const onSaveChanges = async() => {
        onUpdate();
        await setHasChanges(false);
        // await buildMenuOptions();
    }

    const onUpdate = () => {
        if(props.actions && props.actions.update) {
            props.actions.update(sueItem);
            if(changeComments.length > 0) {
                changeComments.forEach((comment: any) => {
                    addSigningComment(comment);
                })
            }
        }
    }
    
    const onAddOfferOptionClick = (type: number) => {
        if (props.actions.showAddTreatmentPopup) {
            props.actions.showAddTreatmentPopup(type, sueItem.customerId);
        }
        dispatch(setCreateTreatmentFrom({ type: 'sue', id: sueItem.id }));
        dispatch(setSueInsuranceCompanyId(sueItem.insuranceCompanyId));
    }
    
    
    const handleButtonClick = () => {
        // Programmatically click the hidden file input
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = async (event: any) => {
        const fileUploaded = event.target.files[0];
        const fileSize: string =((fileUploaded.size/1024)/1024).toFixed(4);
        if (parseFloat(fileSize) > 5) {
            return;
        }
        const reader = new FileReader();
        if (reader !== undefined && fileUploaded !== undefined) {
            reader.onloadend = async() => {
                const fileName = fileUploaded.name;
                await suesModel.sueFileUpload({
                    sueId: sueItem.id,
                    name: fileName,
                    file: reader.result
                });
            }
            reader.readAsDataURL(fileUploaded);
        }
    };

    const redirectToClient = () => {

        const savedTabsStr = localStorage.getItem('clientsOpenTabs');
        let savedTabs: any[] = [];
        if (savedTabsStr) {
            savedTabs = JSON.parse(savedTabsStr);
        }
        const existingTab = savedTabs.find(t => t.id === sueItem.customer.id);
        if (existingTab) {
            // Tab already exists, no need to add again
            navigate(`/Clients/`);
            return;
        } 
        // Add new tab
        const tContent: any = {
            type: "editCustomer",
            title: sueItem.customer.fullName,
            id: sueItem.customer.id,
            mode: 1,
            editData: undefined,
            loaded: false
        }
        savedTabs.push(tContent);
        localStorage.setItem('clientsOpenTabs', JSON.stringify(savedTabs));

        navigate(`/Clients/`);
    }

    const emptyFunc = () => {}
    
    useEffect(()=>{
        const aUrl = localStorage.getItem('apiUrl');
        if (apiUrl == '' && aUrl) {
            setApiUrl(aUrl);
        }
        if (props.config.additionalColumns) {
            setAdditionalColumns(props.config.additionalColumns);
        }
        const signingItem = props.details;
        if (sueItem.rider) {
            setRiderItem(sueItem.rider);
        }
        if (sueItem.elementaryPolicyStatusId && props.statuses) {
            const selectedStatus = props.statuses.find((s: any) => s.value === sueItem.elementaryPolicyStatusId);
            if (selectedStatus) {
                setStatusId(selectedStatus.value)
            }
        }

        // if (insuranceTypes && insuranceTypes.length > 0) {
        //     if (sueItem.policy && sueItem.policy.PolicyAdditionDetails && sueItem.policy.PolicyAdditionDetails.VehiclePolicyType) {
        //         const selected = insuranceTypes.find((s: any) => s.value === sueItem.policy.PolicyAdditionDetails.VehiclePolicyType);
        //         if (selected) {
        //             setInsuranceTypeLabel(selected.label)
        //         }
        //     }
        // }

        // const addOfferOptions: MenuProps['items'] = [
        //     {
        //         key: '0',
        //         label: (
        //             <div className="pointer rtl"
        //                 onClick={()=>{onAddOfferOptionClick(TreatmentType._0)}}
        //             >
        //                 תיעוד שיחה
        //             </div>
        //         ),
        //     },
        //     {
        //         key: '3',
        //         label: 
        //             <div className="pointer rtl"
        //                 onClick={()=>{onAddOfferOptionClick(TreatmentType._3)}}
        //             >
        //                 תיעוד דוא"ל
        //             </div>,
        //     },
        //     {
        //         key: '4',
        //         label: 
        //             <li className="pointer rtl"
        //                 onClick={()=>{onAddOfferOptionClick(TreatmentType._4)}}
        //             >
        //                 תיעוד
        //             </li>,
        //     },
        //     {
        //         key: '6',
        //         label: 
        //             <li className="pointer rtl"
        //                 onClick={()=>{onAddOfferOptionClick(TreatmentType._6)}}
        //             >
        //                 מכתב
        //             </li>,
        //     },
        //     {
        //         key: '1',
        //         label: 
        //             <li className="pointer rtl"
        //                 onClick={()=>{onAddOfferOptionClick(TreatmentType._1)}}
        //             >
        //                 משימה
        //             </li>,
        //     },
        //     {
        //         key: '2',
        //         label: 
        //             <li className="pointer rtl"
        //                 onClick={()=>{onAddOfferOptionClick(TreatmentType._2)}}
        //             >
        //                 וואצפ
        //             </li>,
        //     },
        // ]
        const menuOptions: MenuProps['items'] = [
            {
                label: 
                    <li className="pointer rtl"
                        onClick={onSelectSigning}
                    >
                        עריכה
                    </li>,
                key: 'edit'
            },
            {
                label: 
                    <li className="pointer rtl"
                        onClick={()=>{}}
                    >
                        שלח למייל
                    </li>,
                key: 'sentToEmail'
            },
            {
                label: 
                    <li className="pointer rtl"
                        onClick={()=>{}}
                    >
                        שלח לוואטסאפ
                    </li>,
                key: 'sentToWhatsApp'
            },
            {
                label: 
                    <li className="pointer rtl"
                        onClick={()=>{onAddOfferOptionClick(TreatmentType._1)}}
                    >
                        יצירת משימה
                    </li>,
                key: 'createTask'
            },
           
            {
                label: 
                    <li className="pointer rtl"
                        onClick={()=>handleButtonClick()}
                    >
                        הוספת מסמך
                    </li>,
                key: 'addDocument'
            },
            {
                label: 
                    <li className="pointer rtl"
                        onClick={()=>{}}
                    >
                        הדפס
                    </li>,
                key: 'print'
            },
            {
                label: 
                    <li className="pointer rtl"
                        onClick={()=>{}}
                    >
                        חייג אל
                    </li>,
                key: 'callTo'
            },
            {
                label: 
                    <li className="pointer rtl"
                        onClick={()=>{}}
                    >
                        פתח פוליסה
                    </li>,
                key: 'openPolicy'
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={()=>redirectToClient()}
                    >
                        מעבר לתיק לקוח
                    </li>,
                key: 'openClient'
            }
        ];
        // if (hasChanges) {
        //     menuOptions.push(
        //         {
        //             label: 
        //                 <li className="pointer rtl"
        //                     onClick={emptyFunc}
        //                 >
        //                     עריכה
        //                 </li>,
        //             key: 'edit',
        //             disabled: !hasChanges
        //         }
        //     );
        // }
        // menuOptions.push({
        //     label: 
        //         <li className="pointer rtl"
        //             onClick={()=>{onMenuClicked('assignToHandler')}}
        //         >
        //             שיוך לחתמת
        //         </li>,
        //     key: 'assignToHandler',
        // })
        if (isAdmin) {
            menuOptions.push({
                label: 
                    <li className="pointer rtl"
                        onClick={()=>{onMenuClicked('delete')}}
                    >
                        מחק
                    </li>,
                key: 'delete',
            })
        }
        setSuesMenuOptions(menuOptions);
        
    }, [props])

    // useEffect(()=>{
    //     // buildMenuOptions();
    // }, [isAdmin, hasChanges])

    useEffect(()=>{
        const signingItem = props.details;
        setSueItem(signingItem);

        let isAdmin = false;
        const savedLoggedUser = localStorage.getItem('loggedUser');
        let loggedUser: any = {}
        if (savedLoggedUser) {
            loggedUser = JSON.parse(savedLoggedUser);
            isAdmin = loggedUser.role == 0;
            setIsAdmin(isAdmin);
        }
        // set point color
        let statusIconClass = 'no-color';
        const isVechicle: boolean =  sueItem.policy && sueItem.policy.policyType && sueItem.policy.policyType.policyTypeId == 1;
        const isAppartment: boolean =  sueItem.policy && sueItem.policy.policyType && (sueItem.policy.policyType.policyTypeId == 2 || sueItem.policy.policyType.policyTypeId == 3);
        
        // טיפול משפטי
        // ממתין לשיבוב
        if(sueItem.sueStatusId == "0352e030-455b-46e9-9d4e-c9e73707f921"){
            statusIconClass = 'grey';
            
        } else if (sueItem.sueActivityStatusId == 'f4e67fce-c228-4397-94dc-91c6c7255de5' || sueItem.sueActivityStatusId == '5473d642-53f3-497b-9603-07bae24d47e1') {
            statusIconClass = 'not-new';
        } else {

            if (isVechicle) {

                statusIconClass = 'new';
                if (typesVechicle21Day.includes(sueItem.sueTypeId)) {
                    if (moment().diff(moment(sueItem.openingDate).startOf('day'), 'days') > 21) {
                        statusIconClass = 'not-new';
                    }
                    if (moment().diff(moment(sueItem.openingDate).startOf('day'), 'days') > 30) {
                        statusIconClass = 'old';
                    }
                }
                if (typesVechicle45Day.includes(sueItem.sueTypeId)) {
                    if (moment().diff(moment(sueItem.openingDate).startOf('day'), 'days') > 45) {
                        statusIconClass = 'not-new';
                    }
                    if (moment().diff(moment(sueItem.openingDate).startOf('day'), 'days') > 70) {
                        statusIconClass = 'old';
                    }
                }
            } else {
                if (isAppartment) {
                    statusIconClass = 'new';
                    if (moment().diff(moment(sueItem.openingDate).startOf('day'), 'days') > 21) {
                        statusIconClass = 'not-new';
                    }
                    if (moment().diff(moment(sueItem.openingDate).startOf('day'), 'days') > 45) {
                        statusIconClass = 'old';
                    }
                } else {
                    if (!sueItem.rider) {
                        statusIconClass = 'new';
                        if (moment().diff(moment(sueItem.openingDate).startOf('day'), 'days') > 14) {
                            statusIconClass = 'not-new';
                        }
                        if (moment().diff(moment(sueItem.openingDate).startOf('day'), 'days') > 21) {
                            statusIconClass = 'old';
                        }
                    }
                }
            }
        }
            

        if (sueItem.rider) {
            statusIconClass =  'no-color';
        }
        // if (sueItem.sueActivityStatusId == '1f77b410-1580-4dc1-949f-8c5b26ad5152' || sueItem.sueStatusId == '2cd2f38a-0ab0-4c19-9568-b619a6da869f') {
        //     statusIconClass = 'grey';
        // } else {
        // }
        console.log('sueItem.statusIconClass', statusIconClass)

        // console.log('statusIconClass', statusIconClass, sueItem.policy && sueItem.policy.policyNumber, sueItem.createdDate, moment().diff(moment(sueItem.createdDate).startOf('day'), 'days'))
        setIconClass(statusIconClass);
        
        setIsAdmin(isAdmin);
        const setInsuranceTypesString = localStorage.getItem('insuranceTypes');
        if (!setInsuranceTypesString) {
            const insuranceTypesList: any[] = [];
            generalModel.getAppDictionaryListExpanded().then((insuranceTypesData: any)=>{
                const itTempDataKeys = Object.keys(insuranceTypesData);
                itTempDataKeys.forEach((k: string) => {
                    insuranceTypesList.push({
                        value: insuranceTypesData[k].id,
                        label: insuranceTypesData[k].description,
                        id: insuranceTypesData[k].id,
                        name: insuranceTypesData[k].description,
                    })
                });
                localStorage.setItem('insuranceTypes', JSON.stringify(insuranceTypesList));
                setInsuranceTypes(insuranceTypesList)
            })
            // const insuranceTypesData = await generalModel.getAppDictionaryListExpanded();
        } else {
            const insTypes = JSON.parse(setInsuranceTypesString)
            setInsuranceTypes(insTypes);
            if (sueItem.policy && sueItem.policy.vehiclePolicyType >= 0) {
                const selected = insTypes.find((s: any) => s.value === sueItem.policy.vehiclePolicyType);
                if (selected) {
                    setInsuranceTypeLabel(selected.label)
                }
            }
        }
    },[]);


    const getIcon = (policyItemItem: any) => {
        if(policyItemItem.policyType) {
            let policyType = policyItemItem.policyType
            switch (policyType.policyTypeId) {
                case 1: // רכב 
                    return 'vehicle';
                case 2: // בית
                    return 'house';
                case 3: // עסק
                    return 'buisness';
                case 4: // ביטוח חיים
                    return 'life';
                case 5: // בריאות
                    return 'health';
                case 6: // עסקי
                    return 'proffessional';
                case 9: // ביטוח סוג רכב אחר
                    return 'vehicle';
                case 12: // ימי או אוויר
                    return 'marine';
                default:
                    return 'other'; // ברירת מחדל לרכב פרטי
            }
        }
    }
    
    return (
        <>
            <Dropdown menu={{ items: suesMenuOptions }} trigger={['contextMenu']}>
                <div className={`sue-details-row`} onDoubleClick={(e: any) => onRowClick(e)} style={{backgroundColor: hasChanges ?'#ECECEC' : ''}}>
                        <div className={`status-icon ${iconClass}`}>
                            <div className={`sue-status-circle ${iconClass}`}></div>
                        </div>
                        <div className="client-name" title="מס' תביעה">
                            <div className="description cell-value">
                            {sueItem.sueNumber}
                            </div>
                        </div>
                        <div className={`client-id ${!additionalColumns || !additionalColumns.includes("מס' פנימי") ? 'hide' : ''}`}  title='מס פנימי'>
                            <div className="description cell-value">
                                {sueItem.internalNumber}
                            </div>
                        </div>
                        <div className="created" title="מס' פוליסה">
                            <div className="description cell-value">
                            {sueItem.policy && sueItem.policy.policyNumber}
                            {sueItem.rider && sueItem.rider.subscriberNumber}
                            </div>
                        </div>
                        <div className={`sue-policy-type`} title='סוג פוליסה  '>
                            <div className="description cell-value flex-start">
                            {sueItem.rider ? 
                            (<>
                                <div className="icon policy-type road-services"></div>
                                שרותי דרך
                            </>) : (<></>)}
                            {sueItem.policy ? 
                            (<>
                                {sueItem.policy.policyType ? 
                                (<>
                                <div className={`icon policy-type ${getIcon(sueItem.policy)}`}></div>
                                {sueItem.policy.policyType.name}
                                </>) : (<></>)}
                            </>) : (<></>)}
                            </div>
                        </div>
                        <div className={`alertDate  ${!additionalColumns || !additionalColumns.includes("סוג ביטוח") ? 'hide' : ''}`} title='סוג ביטוח'>
                            <div className="description cell-value">
                            {insuranceTypeLabel}
                            </div>
                        </div>
                        {props.fromClient ? <></> : (
                        <div className="client-name " title='שם לקוח'>
                            <div className="description cell-value">
                            {sueItem.customer ? 
                            (<>
                            {sueItem.customer.fullName}
                            </>) : (<></>)}
                            </div>
                        </div>
                        )}
                        <div className={`route-name ${!additionalColumns || !additionalColumns.includes("ת.ז. לקוח") ? 'hide' : ''}`} title='ת.ז. לקוח'>
                            <div className="description cell-value">
                            {sueItem.customer ? 
                            (<>
                            {sueItem.customer.identifier}
                            </>) : (<></>)}
                            </div>
                        </div>
                        <div className={`insurance ${!additionalColumns || !additionalColumns.includes("פרטי נכס") ? 'hide' : ''}`} title="פרטי נכס">
                            <div className="description cell-value">
                            {sueItem.driver && sueItem.driver.vehicle ? 
                            (<>
                                {sueItem.driver.vehicle.licenseNumber}
                            </>) : (<></>)}
                            </div>
                        </div>
                        <div className={`insurance ${!additionalColumns || !additionalColumns.includes("שנת ייצור") ? 'hide' : ''}`} title="שנת ייצור">
                            <div className="description cell-value">
                            {sueItem.driver && sueItem.driver.vehicle && sueItem.driver.vehicle.carYear ? 
                            (<>
                                {sueItem.driver.vehicle.carYear}
                            </>) : (<></>)}
                            </div>
                        </div>
                        <div className="sueDate" title='ת. פתיחה'>
                            <div className="description cell-value">
                                {moment(sueItem.openingDate).format('DD-MM-YYYY')}
                            </div>
                        </div>
                        <div className="sueDate" title='ת. מקרה'>
                            <div className="description cell-value">
                                {sueItem.sueAccidentAndDamageInfo ? <>
                                {moment(sueItem.sueAccidentAndDamageInfo.accidentDateTime).format('DD-MM-YYYY')}
                                <span style={{color: 'gray',display: 'flex',marginRight: '15px'}}> {moment(sueItem.sueAccidentAndDamageInfo.accidentDateTime).format('HH:mm')}</span>
                                </> : <></>}
                            </div>
                        </div>
                        <div className="license-id" title='סוג תביעה'>
                            <div className="description cell-value">
                                {sueItem.sueTypeLabel}
                            </div>
                        </div>
                        <div className="alertDate" title='מצב תביעה'>
                            <div className="description cell-value">
                            {/* {sueItem.activityStatus} */}
                            {sueItem.activityStatusLabel}
                            </div>
                        </div>
                        <div className="alertDate" title='סטטוס תביעה'>
                            <div className="description cell-value">
                            {/* {sueItem.status} */}
                            {sueItem.statusLabel}
                            </div>
                        </div>
                        <div className="creator" title={`מס' תביעה צ"ג`}>
                            <div className="description cell-value">
                            {sueItem.thirdPartySueNumber && sueItem.thirdPartySueNumber ? sueItem.thirdPartySueNumber : ''}
                            </div>
                        </div>
                        <div className={`alertDate ${!additionalColumns || !additionalColumns.includes("תאריך סגירה") ? 'hide' : ''}`} title='תאריך סגירה'>
                            <div className="description cell-value">
                            {moment(sueItem.closingDate).format('DD-MM-YYYY') !== '01-01-0001' ? 
                            (
                                moment(sueItem.closingDate).format('DD-MM-YYYY')
                            ) : (<></>) }
                            </div>
                        </div>
                        <div className="insurance-company" title='חברה מבטחת'>
                            <div className="description cell-value">
                                {sueItem.insuranceCompany ? 
                                (<>
                                {sueItem.insuranceCompany.name}
                                </>) : sueItem.rider ? 'פלוס שירותי דרך' : (<></>)}
                            </div>
                        </div>
                        <div className={`creator ${!additionalColumns || !additionalColumns.includes("סוכן") ? 'hide' : ''}`} title='סוכן'>
                            <div className="description cell-value">
                            {sueItem.agent ? 
                            (<>
                            {sueItem.agent.fullName}
                            </>) : (<></>)}
                            </div>
                        </div>
                        <div className={`creator ${!additionalColumns || !additionalColumns.includes("חברה נתבעת") ? 'hide' : ''}`} title='חברה נתבעת'>
                            <div className="description cell-value">
                            {sueItem.branch ? 
                            (<>
                            {sueItem.branch.name}
                            </>) : (<></>)}
                            </div>
                        </div>
                        <div className="creator" title='מטפל בתביעה'>
                            <div className="description cell-value">
                            {sueItem.handler ? 
                            (<>
                            {sueItem.handler.fullName}
                            </>) : (<></>)}
                            </div>
                        </div>
                        <div className={`creator ${!additionalColumns || !additionalColumns.includes("נוצר ע\"י") ? 'hide' : ''}`} title='נוצר ע"י'>
                            <div className="description cell-value">
                            {sueItem.creatorUser ? 
                            (<>
                            {sueItem.creatorUser.fullName}
                            </>) : (<></>)}
                            </div>
                        </div>
                        <div className={`sue-price ${!additionalColumns || !additionalColumns.includes("סכום שנתבע") ? 'hide' : ''}`} title='סכום שנתבע'>
                            <div className="description cell-value">
                            {sueItem.requestedAmount ? 
                            (<>
                            &#8362;{sueItem.requestedAmount}
                            </>) : (<></>)}
                            </div>
                        </div>
                        <div className={`sue-price ${!additionalColumns || !additionalColumns.includes("סכום שאושר") ? 'hide' : ''}`} title='סכום שאושר'>
                        <div className="description cell-value">
                            {sueItem.approvedAmount ? 
                            (<>
                            &#8362;{sueItem.approvedAmount}
                            </>) : (<></>)}
                            </div>
                        </div>
                        {/* <div className="status" title='סטטוס'>
                            <div className="description cell-value">
                                    <Select
                                        value={statusId}
                                        style={{ width: '140px' }}
                                        options={[
                                            {
                                                label: 'חדש',
                                                value: '0'
                                            },
                                            ...(props.statuses ? props.statuses : [])
                                        ]}
                                        onChange={onStatusChange}
                                    />
                            </div>
                        </div>
                        <div className={`creator ${!additionalColumns || additionalColumns.agent.hidden ? 'hide' : ''}`} title='סוכן'>
                            <div className="description cell-value">
                                {}
                            </div>
                        </div>
                        <div className={`creator ${!additionalColumns || additionalColumns.clientsGroups.hidden ? 'hide' : ''}`} title='קבוצת לקוחות'>
                            <div className="description cell-value">
                            
                            </div>
                        </div> */}
                        <div className="actions">
                            <Dropdown menu={{ items: suesMenuOptions }}>
                                <div className="act-btn-icon icon menu-hamburger pointer"></div>
                            </Dropdown>
                        </div>
                    {/* <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: "none" }}
                                        onChange={handleFileChange}
                                    /> */}
                </div>
            </Dropdown>
        </>
    )
}

export default SueItem;